import Injectable from '@/modules/shared/domain/di/injectable';
import { CustomerGeolocationsRepository } from '../../../domain/repositories/customer-geolocations-repository';

@Injectable()
export default class CustomerGeolocationsDummyRepository implements CustomerGeolocationsRepository {
  create() {
    return Promise.resolve();
  }
}
